import type { IconSvgObject } from './types';

const PrinterXIcon: IconSvgObject = [
  ["path", { d: "M22 13V11C22 9.34315 20.6569 8 19 8H5C3.34315 8 2 9.34315 2 11V17C2 17.5523 2.44772 18 3 18H7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 8V3.5C17 2.67157 16.3284 2 15.5 2H8.5C7.67157 2 7 2.67157 7 3.5V8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M13 16H7V20C7 21.1046 7.89543 22 9 22H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M17 22L22 17M22 22L17 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default PrinterXIcon;
